import { checkboxTheme } from './checkbox.theme';
import { hintTheme } from './hint.theme';
import { inputTheme } from './input.theme';
import { labelTheme } from './label.theme';
import { radioTheme } from './radio.theme';
import { selectTheme } from './select.theme';
import { toggleTheme } from './toggle.theme';

export const formTheme = {
  checkbox: checkboxTheme,
  hint: hintTheme,
  input: inputTheme,
  label: labelTheme,
  radio: radioTheme,
  select: selectTheme,
  toggle: toggleTheme,
};
